class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredAttributes() {
    return ["data-animation-duration"];
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this.maxIndex || this.maxIndex < 1) return;

    setInterval(() => {
      if (this.paused) return;

      this.currentIndex = this.currentIndex + 1;
    }, this.animationDuration);
  }

  setupListeners() {
    super.setupListeners();

    this.listeners.add(this, "mouseenter", () => {
      this.paused = true;
    });
    this.listeners.add(this, "mouseleave", () => {
      this.paused = false;
    });

    this.listeners.add(this, "focusin", () => {
      this.paused = true;
    });
    this.listeners.add(this, "focusout", () => {
      this.paused = false;
    });
  }

  set previousIndex(index) {
    this._previousIndex = index > -1 ? index : this.maxIndex;
    this.els.item.elements?.[this._previousIndex]?.setAttribute(
      "aria-hidden",
      "true",
    );
  }

  get previousIndex() {
    return this._previousIndex;
  }

  set currentIndex(index) {
    this._currentIndex = index <= this.maxIndex ? index : 0;
    this.previousIndex = this._currentIndex - 1;
    this.els.item.elements?.[this._currentIndex]?.setAttribute(
      "aria-hidden",
      "false",
    );
  }

  get currentIndex() {
    return this._currentIndex || 0;
  }

  get maxIndex() {
    return this.els?.item?.elements?.length
      ? this.els.item.elements.length - 1
      : null;
  }

  get animationDuration() {
    return (Number(this.dataset.animationDuration) || 5) * 1000;
  }
}

if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", AnnouncementBar);
}
